import React, { ButtonHTMLAttributes } from 'react';
import styles from './primaryButton.module.scss';
import classNames from 'classnames';

const PrimaryButton: React.FC<ButtonHTMLAttributes<HTMLButtonElement> & { btnType?: 'outline' | 'link' }> = props => {
  const { className, btnType, ...otherProps } = props;
  const btn = {
    outline: 'sm:border-[2px]! sm:border-primary-2! sm:bg-white!',
    link: 'border-none! bg-transparent! normal-case! text-gray-600! text-base! font-RoobertPRO!'
  } as const;
  return (
    <button
      data-testid="primary-button"
      className={`text-base! sm:text-sm! ${btnType && btn[btnType]} ${classNames(styles.primary, className)}`}
      {...otherProps}
    >
      {props.children}
    </button>
  );
};

export default PrimaryButton;
